module.exports = __webpack_public_path__ + "img/logo.165b6023.svg";